import { datajs, datajsAll, setCookieHour, getCookie } from '../shared/utils';
import { Modal } from 'bootstrap';

export default class NewsletterModal {
	static init() {
		const newsletterForms = datajsAll('newsletter-form');
		const newsletterModalElement = datajs('newsletter-modal');
		let newsletterModal = false;

		if (newsletterModalElement) {
			const newsletterModalCloseBtn = datajs('newsletter-modal-close');
			const cookie = getCookie('nwlettersignup') || '';

			newsletterModal = new Modal(newsletterModalElement);

			// Only show the modal if the user has not seen it yet
			if (cookie !== 'shown') {
				setTimeout(function () {
					newsletterModal.show();
				}, 10000);
			}

			// When the user closes the modal by clicking the close button
			if (newsletterModalCloseBtn) {
				newsletterModalCloseBtn.addEventListener('click', function () {
					// Don't bother the user with the newsletter signup form for another 36 hours
					setCookieHour('nwlettersignup', 'shown', 36);

					newsletterModal.hide();
				});
			}
		}

		// When the user submits any newsletter form on the website
		newsletterForms.forEach((form) => {
			form.addEventListener('submit', function () {
				// Don't show newsletter modal for a year if user has submittet the newsletter form
				setCookieHour('nwlettersignup', 'shown', 8765);

				if (newsletterModalElement) {
					newsletterModal.hide();
				}
			});
		});
	}
}
